import { useEffect } from 'react';

//This effect is required when sticky pagination is enabled to correctly place the pagination container
// always at the bottom of the table parent
export const usePaginationPosition = (
  enableStickyPagination: boolean | undefined,
  currentPage: number,
  totalRecords: number,
  parentContainerId: string | undefined,
  rowsPerPage: number,
) => {
  useEffect(() => {
    if (enableStickyPagination && parentContainerId) {
      const parentContainer = document.getElementById(parentContainerId);
      if (parentContainer) {
        const paginationContainer = parentContainer.querySelector('#pagination-container');
        if (parentContainer.scrollHeight > parentContainer.clientHeight && paginationContainer) {
          paginationContainer.setAttribute('style', 'bottom:0');
        } else if (paginationContainer) {
          paginationContainer.setAttribute('style', 'top:100%');
        }
      }
    }
  }, [enableStickyPagination, currentPage, totalRecords, parentContainerId, rowsPerPage]);
};
